'use strict';

angular.module('ringbaPortal.services').factory('affiliateService', affiliateService);

function affiliateService(_, $http, $q, ngAuthSettings, accountsService, promiseCacheService) {
  'ngInject';
  
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const columnSettings = {
    name: {
      class: 'tablesort-sortable',
      stSort: 'name',
      displayName: 'PUBLISHERS_NAME'
    },
    id: {
      displayName: 'PUBLISHERS_ID'
    },
    createNumbers: {
      class: 'tablesort-sortable',
      stSort: 'createNumbers',
      displayName: 'PUBLISHERS_PERMISSIONS_NUMBER'
    },
    currentLive: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentLive',
      displayName: 'PUBLISHERS_CURRENT_LIVE',
      rowAlign: 'right'
    },
    currentHour: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentHour',
      displayName: 'PUBLISHERS_CURRENT_HOUR',
      rowAlign: 'right'
    },
    currentDay: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentDay',
      displayName: 'PUBLISHERS_CURRENT_DAY',
      rowAlign: 'right'
    },
    currentMonth: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentMonth',
      displayName: 'PUBLISHERS_CURRENT_MONTH',
      rowAlign: 'right'
    },
    total: {
      class: 'tablesort-sortable text-right',
      stSort: 'total',
      displayName: 'PUBLISHERS_TOTAL',
      rowAlign: 'right'
    },
    enabled: {
      class: 'tablesort-sortable',
      stSort: 'enabled',
      displayName: 'PUBLISHERS_STATUS',
      rowAlign: 'center'
    }
  };

  const defaultColumns = ['name', 'id', 'createNumbers', 'currentLive', 'currentHour', 'currentDay', 'currentMonth', 'total', 'enabled'];

  const service = {
    getAffiliates: getAffiliates,
    getCachedAffiliates: getCachedAffiliates,
    getAffiliatesStats: getAffiliatesStats,
    getAffiliate: getAffiliate,
    createAffiliate: createAffiliate,
    updateAffiliate: updateAffiliate,
    columnSettings: columnSettings,
    defaultColumns: defaultColumns,
    initializePayoutCaps: initializePayoutCaps,
    resetCallCaps: resetCallCaps,
    removePayoutCaps: removePayoutCaps,
    getSelfPublisher: getSelfPublisher,
    getNonSelfPublishers: getNonSelfPublishers,
    isSelfPub: isSelfPub,
    getAffiliateReferences: getAffiliateReferences,
    deleteAffiliate: deleteAffiliate
  };

  return service;

  function getNonSelfPublishers(accountId) {
    return getAffiliates(accountId).then(function (response) {
      return _.filter(response.data.affiliates, function(o){
        return !isSelfPub(o);
      });
    });
  }

  function getSelfPublisher(accountId) {
    return getAffiliates(accountId).then(function (response) {
      return _.find(response.data.affiliates, function(o){
        return isSelfPub(o);
      });
    });
  }

  function getAffiliates(accountId, getStats) {
    const url = serviceBaseUri + accountId + '/affiliates' + (getStats ? '?includestats=true' : '');
    return _returnGetPromise(url);
  }

  function getCachedAffiliates(accountId, getStats) {
    const url = serviceBaseUri + accountId + '/affiliates' + (getStats ? '?includestats=true' : '');
    return promiseCacheService.getCallWithCachedPromise(_getCacheKey(accountId, getStats), url, 30)
      .catch(function () {
        return {
          data: {
            affiliates: []
          }
        }; });
  }

  function getAffiliatesStats(accountId) {
    const url = serviceBaseUri + accountId + '/affiliates/stats';
    return _returnGetPromise(url);
  }

  function getAffiliate(accountId, affiliateId) {
    const url = _serviceBaseUrl(accountId, affiliateId);
    return _returnGetPromise(url);
  }

  function createAffiliate(accountId, affiliate) {
    const url = serviceBaseUri + accountId + '/affiliates';
    return $http.post(url, affiliate);
  }

  function updateAffiliate(accountId, affiliate) {
    const url = _serviceBaseUrl(accountId, affiliate.id);
    const data = _sanitizeAffiliate(affiliate);
    return $http.patch(url, data);
  }

  function _returnGetPromise(url) {
    if (_canView()) {
      return $http.get(url).catch(
        function () {
          return {
            data: {
              affiliates: []
            }
          }; });
    } else {
      const deferred = $q.defer();
      deferred.resolve({
        data: {
          affiliates: []
        }
      });
      return deferred.promise;
    }
  }

  function initializePayoutCaps(payoutSettings) {
    const payoutCaps = {};
    try {
      if (payoutSettings.allTimeCap > -1) {
        payoutCaps.allTimeCap = 1;
      } else {
        delete payoutSettings.allTimeCap;
        payoutCaps.allTimeCap = -1;
      }
      if (payoutSettings.monthlyCap > -1) {
        payoutCaps.monthlyCap = 1;
      } else {
        delete payoutSettings.monthlyCap;
        payoutCaps.monthlyCap = -1;
      }
      if (payoutSettings.dailyCap > -1) {
        payoutCaps.dailyCap = 1;
      } else {
        delete payoutSettings.dailyCap;
        payoutCaps.dailyCap = -1;
      }
      if (payoutSettings.hourlyCap > -1) {
        payoutCaps.hourlyCap = 1;
      } else {
        delete payoutSettings.hourlyCap;
        payoutCaps.hourlyCap = -1;
      }
      if (payoutSettings.concurrencyCap > -1) {
        payoutCaps.concurrencyCap = 1;
      } else {
        delete payoutSettings.concurrencyCap;
        payoutCaps.concurrencyCap = -1;
      }

      if (payoutSettings.allTimeSumCap > -1) {
        payoutCaps.allTimeSumCap = 1;
      } else {
        delete payoutSettings.allTimeSumCap;
        payoutCaps.allTimeSumCap = -1;
      }
      if (payoutSettings.monthlySumCap > -1) {
        payoutCaps.monthlySumCap = 1;
      } else {
        delete payoutSettings.monthlySumCap;
        payoutCaps.monthlySumCap = -1;
      }
      if (payoutSettings.dailySumCap > -1) {
        payoutCaps.dailySumCap = 1;
      } else {
        delete payoutSettings.dailySumCap;
        payoutCaps.dailySumCap = -1;
      }
      if (payoutSettings.hourlySumCap > -1) {
        payoutCaps.hourlySumCap = 1;
      } else {
        delete payoutSettings.hourlySumCap;
        payoutCaps.hourlySumCap = -1;
      }
    } catch {
      // empty
    }
    return payoutCaps;
  }

  function removePayoutCaps(payoutSettings, payoutCaps) {
    delete payoutSettings.allTimeCap;
    delete payoutSettings.monthlyCap;
    delete payoutSettings.dailyCap;
    delete payoutSettings.hourlyCap;
    delete payoutSettings.concurrencyCap;

    delete payoutSettings.allTimeSumCap;
    delete payoutSettings.monthlySumCap;
    delete payoutSettings.dailySumCap;
    delete payoutSettings.hourlySumCap;

    _.forOwn(payoutCaps, function (value, key) {
      payoutCaps[key] = -1;
    });
  }

  function resetCallCaps(payoutCaps, payoutSettings) {
    payoutCaps = payoutCaps || {};
    payoutSettings = payoutSettings || {};
    if (payoutCaps.allTimeCap === -1) { payoutSettings.allTimeCap = -1; }
    if (payoutCaps.monthlyCap === -1) { payoutSettings.monthlyCap = -1; }
    if (payoutCaps.dailyCap === -1) { payoutSettings.dailyCap = -1; }
    if (payoutCaps.hourlyCap === -1) { payoutSettings.hourlyCap = -1; }
    if (payoutCaps.concurrencyCap === -1) { payoutSettings.concurrencyCap = -1; }

    if (payoutCaps.allTimeSumCap === -1) { payoutSettings.allTimeSumCap = -1; }
    if (payoutCaps.monthlySumCap === -1) { payoutSettings.monthlySumCap = -1; }
    if (payoutCaps.dailySumCap === -1) { payoutSettings.dailySumCap = -1; }
    if (payoutCaps.hourlySumCap === -1) { payoutSettings.hourlySumCap = -1; }
    return payoutCaps;
  }

  function getAffiliateReferences(accountId, affiliateId) {
    const url = _serviceBaseUrl(accountId, affiliateId) + '/InboundReferences';
    return $http.get(url);
  }

  function deleteAffiliate(accountId, affiliateId, force, keepNumbers) {
    const url = _serviceBaseUrl(accountId, affiliateId) + '?force=' + force + '&keepNumbers=' + keepNumbers;
    return $http.delete(url);
  }

  function _sanitizeAffiliate(affiliate) {
    const sanitized = {
      id: affiliate.id,
      accountId: affiliate.accountId
    };

    if (affiliate.name) {
      sanitized.name = affiliate.name;
    } else {
      sanitized.name = '';
    }
    
    if (affiliate.subId) {
      sanitized.subId = affiliate.subId;
    } else {
      sanitized.subId = '';
    }
    if (typeof affiliate.enabled !== 'undefined') {
      sanitized.enabled = affiliate.enabled;
    }
    sanitized.createNumbers = !!affiliate.createNumbers;

    sanitized.blockCallsIfCapped = affiliate.blockCallsIfCapped;
    sanitized.accessToRecordings = affiliate.accessToRecordings;

    if (affiliate.isSelf) {
      sanitized.isSelf = affiliate.isSelf;
    }
    if (affiliate.loginId) {
      sanitized.loginId = affiliate.loginId;
    }
    return sanitized;
  }

  function _serviceBaseUrl(accountId, affiliateId) {
    return serviceBaseUri + accountId + '/affiliates/' + affiliateId;
  }

  function _canView() {
    return !accountsService.isAffiliate() && !accountsService.isBuyer();
  }

  function isSelfPub(publisher) {
    if(!publisher)
      return false;
    if (publisher.isSelf)
      return true;

    const name = publisher.name.toLowerCase();
    return name === 'self' || name === 'you';
  }

  function _getCacheKey(accountId, getStats) {
    return 'affiliatesGetPromise' + accountId + (getStats ? 'includestats' : '');
  }
}
